let environment = {
  production: false,
  url: 'https://api.farmacia.dev.puntosalud.ar/api/v1/nuvalid-farmacia',
};

export { environment };
